var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_13164)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_65_13164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6849 6.38266C17.7925 6.26242 17.9243 6.16623 18.0716 6.10038C18.219 6.03453 18.3785 6.00049 18.5399 6.00049C18.7013 6.00049 18.8608 6.03453 19.0082 6.10038C19.1555 6.16623 19.2873 6.26242 19.3949 6.38266C19.8674 6.89191 19.8674 7.71766 19.3949 8.22691L10.6867 17.6177C10.5789 17.7378 10.447 17.8339 10.2997 17.8997C10.1523 17.9655 9.99268 17.9995 9.83128 17.9995C9.66989 17.9995 9.5103 17.9655 9.36292 17.8997C9.21554 17.8339 9.08367 17.7378 8.97591 17.6177L5.10516 13.4432C4.87701 13.1901 4.75073 12.8614 4.75073 12.5207C4.75073 12.1799 4.87701 11.8512 5.10516 11.5982C5.21292 11.4781 5.34474 11.3821 5.49205 11.3164C5.63936 11.2507 5.79886 11.2167 5.96016 11.2167C6.12146 11.2167 6.28096 11.2507 6.42827 11.3164C6.57558 11.3821 6.7074 11.4781 6.81516 11.5982L9.83091 14.8502L17.6849 6.38266Z",
    fill: "#34CC8D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_13164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_65_13164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.79ea0c20bfd83cddc752e2c7555bfd95.svg";
export { ForwardRef as ReactComponent };